var _effectorFileName = "/builds/gmini/front-ui-kit/src/ResizableColumns/Resizer/Resizer.tsx";
import React from 'react';
import { ButtonRoot, ButtonText, ResizerRoot } from './Resizer.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const Resizer = ({ ...rest
}) => /*#__PURE__*/_jsx(ResizerRoot, { ...rest,
  children: /*#__PURE__*/_jsx(ButtonRoot, {
    children: /*#__PURE__*/_jsx(ButtonText, {
      children: ". . ."
    })
  })
});